// Simple pub/sub with a guard to avoid redeclaration when bundled
if (typeof window === 'undefined' || !window.EventEmitter) {
  class EventEmitter {

     constructor() {
        this.callbackList = window.EventEmitterCallbackList || {};
     }

     subscribe(event, callback) {
        if(typeof this.callbackList[event] == 'undefined') {
           this.callbackList[event] = [];
        }

        this.callbackList[event].push(callback);
     } 

     next(event, value) {

        if(typeof this.callbackList[event] !== 'undefined') {

           this.callbackList[event].forEach(function(ev) {
              ev(value);
           });

        }

     }

  }

  if (typeof window !== 'undefined') {
    window.EventEmitter = EventEmitter;
  } else {
    globalThis.EventEmitter = EventEmitter;
  }
}